<template>
  <div>
    <FormCrearSillon
        v-if="modo === 'crear'"
        :listaSillones="listaSillones"
        :nombreClinica="nombreClinica"
        :idClinica="idClinica"
        :diasOperativos="diasOperativos"
        :listaDias="listaDias"
        :listaHorariosSillon="listaHorariosSillon"
        @guardar="$emit('guardarHorarioSillon', $event)"
        @cerrar="$emit('cerrarModalSillon')"
    />
    <FormInhabilitarSillon
        v-else-if="modo === 'inhabilitar'"
        :listaSillones="listaSillones"
        :nombreClinica="nombreClinica"
        :idClinica="idClinica"
        :diasOperativos="diasOperativos"
        :listaDias="listaDias"
        :seleccionInhabilitar="seleccionInhabilitar"
        @inhabilitar="$emit('inhabilitarHorario', $event)"
        @cerrar="$emit('cerrarModalSillon')"
    />
    <FormHabilitarSillon
        v-else-if="modo === 'habilitar'"
        :nombreClinica="nombreClinica"
        :idClinica="idClinica"
        :diasOperativos="diasOperativos"
        :listaDias="listaDias"
        :seleccionInhabilitar="seleccionInhabilitar"
        @guardar="$emit('guardarHorarioSillon', $event)"
        @cerrar="$emit('cerrarModalSillon')"
    />
  </div>
</template>

<script>
import FormCrearSillon from './FormCrearSillon.vue';
import FormInhabilitarSillon from './FormInhabilitarSillon.vue';
import FormHabilitarSillon from './FormHabilitarSillon.vue';

export default {
  name: "ModalCrearHorarioSillon",
  components: { FormCrearSillon, FormInhabilitarSillon, FormHabilitarSillon },
  props: {
    modo: {
      type: String,
      required: true,
      validator: v => ['crear', 'habilitar', 'inhabilitar'].includes(v),
    },
    listaSillones: Array,
    nombreClinica: String,
    idClinica: Number,
    diasOperativos: Array,
    listaDias: Array,
    seleccionInhabilitar: Object,
    listaHorariosSillon:{ type: Array , required: true },

  },
}
</script>
